// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { ROUTE_CONST } from "~/route/const";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

Mapy.PlacesExportRoute = function(data, isCar) {
	if (!("id" in data) || !("title" in data)) {
		return;
	}

	let state = {
		lang: [encodeURIComponent(CONFIG.langPriority.join(","))], // pozadovane jazyky v poradi priority
		rp_c: [data.data.route[0].routeParams.criterion], // planovaci kriterium pro trasu
		xc: data.data.routeParams.tollExcludeCountries
	};
	let coords = [];
	let rs = [];
	let ri = [];

	data.data.route.forEach(i => {
		coords.push(i.geometry);
		rs.push(i.source ? i.source : "");
		ri.push(i.source != "coor" && i.id ? i.id : "");

		if (i.planTrip) {
			// planovaci kriterium pro vylet
			state.tp_c = [i.tripParams.criterion];

			// waypointy pro rucne upraveny vylet
			if (i.tripParams.waypoints && i.tripParams.waypoints != "") {
				state.tp_w = [i.tripParams.waypoints];
			}

			// index vybraneho vyletu
			state.tp_i = [i.tripParams.tripIndex];
		}
	});

	/**
	 * trojice urcujici body pres ktere se planuje, rs a ri je source a id poie,
	 rg je souradnice, mohou se opakovat, poradi v url je zavazne
	 */
	state.rg = coords;
	state.rs = rs;
	state.ri = ri;

	// planovani s dopravou
	if (data.data.routeParams.useTraffic) {
		state.rut = [1];
	}

	const rbf = [];

	if (data.data.routeParams.avoidHighways) {
		rbf.push("ah");
	}

	if (data.data.routeParams.allowViaFerrata) {
		rbf.push("avf");
	}

	if (rbf.length) {
		state.rbf = rbf;
	}

	if (data.data.routeParams.routeWaypoints) {
		state.rp_aw = [data.data.routeParams.routeWaypoints];
	}

	let criterion = 0;

	data.data.route.every(item => {
		if (item.routeParams && item.routeParams.criterion) {
			criterion = item.routeParams.criterion;
		}
		else return true;
	});

	const nameSource = data.usertitle || data.title;

	new MyMapsExport({
		data: {
			name: "route",
			data: {
				...state,
				title: data.usertitle || data.title,
				name: [encodeURI(nameSource.length < 100 ? nameSource : nameSource.substring(0,100))],
			},
			tponly: ROUTE_CONST.types.car.criterion.indexOf(criterion) > -1,
		},
		fileTypeFromHeader: true,
	}).open();
};
